/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
Command: npx gltfjsx@6.2.16 Pepecoin.glb -t -k -m -s -D 
*/

import * as THREE from 'three'
import React, { useRef } from 'react'
import { useGLTF } from '@react-three/drei'
import { GLTF } from 'three-stdlib'
import { useFrame } from '@react-three/fiber'

type GLTFResult = GLTF & {
  nodes: {
    Cilindro: THREE.Mesh
    ['Diseño_sin_título_(2)']: THREE.Mesh
    ['Diseño_sin_título_(2)005']: THREE.Mesh
  }
  materials: {
    ['Material.001']: THREE.MeshBasicMaterial
    ['Diseño sin título (2)']: THREE.MeshStandardMaterial
    ['Diseño sin título (2).001']: THREE.MeshStandardMaterial
  }
}

type ContextType = Record<string, React.ForwardRefExoticComponent<JSX.IntrinsicElements['mesh']>>

export function Pepecoin(props: JSX.IntrinsicElements['group']) {
  const group = useRef<THREE.Group>(null!);

  const { nodes, materials } = useGLTF('/assets/models/Pepecoin.glb') as GLTFResult

  useFrame((state) => {
    const t = state.clock.getElapsedTime();

    group.current.rotation.y =   t 

  });

  return (
    <group ref={group} {...props} dispose={null}>
      <mesh name="Cilindro" castShadow receiveShadow geometry={nodes.Cilindro.geometry} material={materials['Material.001']} position={[0.07, 0.534, 0.173]} rotation={[-1.537, 0, -Math.PI]} scale={[-0.511, -0.023, -0.525]} userData={{ name: 'Cilindro' }} />
      <mesh name="Diseño_sin_título_(2)" castShadow receiveShadow geometry={nodes['Diseño_sin_título_(2)'].geometry} material={materials['Diseño sin título (2)']} position={[0.065, 0.542, -0.243]} rotation={[1.602, 0, 0]} scale={[1.171, 1.194, 1.204]} userData={{ name: 'Diseño sin título (2)' }} />
      <mesh name="Diseño_sin_título_(2)005" castShadow receiveShadow geometry={nodes['Diseño_sin_título_(2)005'].geometry} material={materials['Diseño sin título (2).001']} position={[0.065, 0.542, -0.308]} rotation={[1.602, 0, 0]} scale={[1.168, 1.219, 1.209]} userData={{ name: 'Diseño sin título (2).005' }} />
    </group>
  )
}

useGLTF.preload('/assets/models/Pepecoin.glb')
